//interfaces
import { IBasicButton } from "interfaces/buttons";

import "../../../../css/global/buttons/LinkStyleButton.scss";

const LinkStyleButton = ({ content, className, isDisabled = false, ariaLabel, onButtonClick, isLink, linkUrl}: IBasicButton) => {

    if (isLink) {
        return (
            <a
            className={`link-style-button ${className} ${isDisabled && "disabled-style-link"}`}
            aria-label={ariaLabel}
            href={linkUrl}
        >
            {content}
        </a>
        )
    }
    return (
        <button
            className={`link-style-button ${className} ${isDisabled && "disabled-style-link"}`}
            disabled={isDisabled}
            aria-label={ariaLabel}
            onClick={onButtonClick}
        >
            {content}
        </button>
    );
};

export default LinkStyleButton